import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';
import { computed } from 'mobx';
import { NonBlockingNotificationType, NotificationType } from 'src_server/trpc/types/accountModel/accountResponse';
import { Common } from 'src/domains/common/Common';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';

export class NonBlockingNotificationsState {
    private readonly basicDataComp: BasicDataModel;

    public constructor(private readonly common: Common) {
        this.basicDataComp = BasicDataModel.get(this.common);
    }

    public static get = AutoWeakMap.create((common: Common) => new NonBlockingNotificationsState(common));

    @computed public get getNonBlockingNotificationType(): NotificationType | null {
        const customerData = this.basicDataComp.basicDataReady;
        if (customerData === null) {
            return null;
        }

        const allNotifications = customerData.prompts?.notificationList ?? [];
        const activeNotifications = [...allNotifications].filter((notification) => notification.active);

        return (
            activeNotifications.find((notification) => {
                switch (notification.name) {
                    case 'reviewAccount':
                        return NonBlockingNotificationType.REVIEW_ACCOUNT;
                }
            })?.name ?? null
        );
    }

    public handleConfirmReviewAccount = async (): Promise<void> => {
        await this.onConfirm(NonBlockingNotificationType.REVIEW_ACCOUNT);
    };

    public handleConfirmReviewLimits = async (): Promise<void> => {
        await this.onConfirm(NonBlockingNotificationType.REVIEW_LIMITS);
    };

    private onConfirm = async (nonBlockingNotificationType: NonBlockingNotificationType): Promise<void> => {
        const confirmedNotification = { name: nonBlockingNotificationType, active: false };

        const allNotifications = this.basicDataComp.basicDataReady?.prompts?.notificationList ?? [];
        const updatedNnotifications = allNotifications.map((notification) =>
            notification.name === nonBlockingNotificationType ? confirmedNotification : notification
        );

        await this.common.trpcClient.client.accounts.approveNotification.mutate({
            prompts: { notificationList: updatedNnotifications },
        });

        this.basicDataComp.basicData.refresh();
    };
}
